var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-content-wrapper"},[_c('div',{staticClass:"cell-content",attrs:{"title":_vm.data}},[_vm._v(_vm._s(_vm.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }